





















import { defineComponent, PropType } from '@nuxtjs/composition-api';

export default defineComponent({
  props: {
    items: {
      type: Array as PropType<any[]>,
      required: true,
    },
    keyProperty: {
      type: String,
      required: true,
    },
    pcCols: {
      type: Number,
      required: true,
    },
    spCols: {
      type: Number,
      required: true,
    },
    spVerticalGap: {
      type: Number,
      required: true,
    },
    pcVerticalGap: {
      type: Number,
      required: true,
    },
  },
});
